import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@hweeks/kei-costs-ui-testids';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';
import { RhdRoot } from '../design';
import { Btn } from '../design/app';
import { useRhdTheme } from '../design/theme';
import { ROUTES } from '../routes';
import './errorBoundary.css';
// Route-level crash screen. Without this, a render error inside any page falls
// through to react-router's built-in overlay ("Unexpected Application Error!"),
// which replaces the whole app chrome with a stack trace and offers no way out.
//
// It also gives the e2e suite a precise signal: asserting this testid is absent
// is a direct "the page did not crash" check, instead of pattern-matching
// framework error text.
export function RouteErrorBoundary() {
    const error = useRouteError();
    const { theme } = useRhdTheme();
    let detail = 'An unexpected error occurred while rendering this page.';
    if (isRouteErrorResponse(error)) {
        detail = `${error.status} ${error.statusText}`;
    } else if (error instanceof Error) {
        detail = error.message;
    }
    // The error replaces the app shell, so this screen brings its own .rhd root.
    return /*#__PURE__*/ _jsx(RhdRoot, {
        theme: theme ?? undefined,
        className: "ra-crash",
        children: /*#__PURE__*/ _jsxs("main", {
            "data-testid": Testids.app.errorBoundary.root,
            className: "ra-crash__card",
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: "ra-crash__seal",
                    "aria-hidden": "true",
                    children: "誤"
                }),
                /*#__PURE__*/ _jsx("h1", {
                    className: "ra-crash__title",
                    children: "Something went wrong"
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "ra-crash__sub",
                    children: "This page hit an error. Your data is safe — reloading usually clears it."
                }),
                /*#__PURE__*/ _jsx("pre", {
                    className: "ra-crash__detail",
                    children: detail
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "ra-crash__actions",
                    children: [
                        /*#__PURE__*/ _jsx(Btn, {
                            variant: "primary",
                            "data-testid": Testids.app.errorBoundary.reloadButton,
                            onClick: ()=>window.location.reload(),
                            children: "Reload page"
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            to: ROUTES.orders,
                            className: "rhd-arrow-link",
                            onClick: ()=>{
                                // Router state is already unwound; force a clean mount.
                                setTimeout(()=>window.location.reload(), 0);
                            },
                            children: "Back to hunts →"
                        })
                    ]
                })
            ]
        })
    });
}
